const sortToastEntries = (entries = []) => {
  return [...entries].sort((left, right) => {
    const leftPersistent = Boolean(left?.persistent);
    const rightPersistent = Boolean(right?.persistent);
    if (leftPersistent !== rightPersistent) {
      return leftPersistent ? -1 : 1;
    }

    const leftOrder = Number(left?.createdAt || 0);
    const rightOrder = Number(right?.createdAt || 0);
    if (leftOrder !== rightOrder) return leftOrder - rightOrder;
    return String(left?.id || '').localeCompare(String(right?.id || ''));
  });
};

export const buildToastStackKey = (where = {}, fallbackKey = 'app') => {
  const docId = where?.docId;
  if (docId !== undefined && docId !== null && String(docId).trim() !== '') {
    return `doc:${String(docId).trim()}`;
  }

  const pane = String(where?.pane || '').trim().toLowerCase();
  if (pane === 'left' || pane === 'right') {
    return `pane:${pane}`;
  }

  return String(fallbackKey || 'app');
};

export const upsertToastEntry = (entries = [], nextEntry) => {
  const normalizedEntries = Array.isArray(entries) ? entries : [];
  const replacementIndex = normalizedEntries.findIndex((entry) => String(entry?.toastId || '') === String(nextEntry?.toastId || ''));
  if (replacementIndex >= 0) {
    const replaced = [...normalizedEntries];
    replaced[replacementIndex] = {
      ...replaced[replacementIndex],
      ...nextEntry,
      createdAt: replaced[replacementIndex]?.createdAt ?? nextEntry?.createdAt ?? Date.now()
    };
    return sortToastEntries(replaced);
  }
  return sortToastEntries([...normalizedEntries, nextEntry]);
};

export const removeToastEntry = (entries = [], toastId = null) => {
  if (!toastId) return Array.isArray(entries) ? entries : [];
  return (Array.isArray(entries) ? entries : []).filter((entry) => String(entry?.toastId || '') !== String(toastId));
};

export const updateToastEntry = (entries = [], toastId = null, updates = {}) => {
  if (!toastId) return Array.isArray(entries) ? entries : [];
  return sortToastEntries((Array.isArray(entries) ? entries : []).map((entry) => (
    String(entry?.toastId || '') === String(toastId)
      ? { ...entry, ...updates }
      : entry
  )));
};
